export default function getInitialPopperStyles(position) {
  if (position === void 0) {
    position = 'absolute';
  }

  return {
    position: position,
    top: '0',
    left: '0',
    opacity: '0',
    pointerEvents: 'none'
  };
}